import {combineCycles} from 'redux-cycles';
import {
  requestUnlockAragUser,
  askForNotificationsIndicatorAfterLogIn,
  getVersion,
  logIn,
  logout,
  receiveFailedResponseAcceptPendingToba,
  receiveFailedResponseGetPendingToba,
  redirectAfterAcceptingToba,
  redirectAragUserAfterLogIn,
  redirectSolicitorUserToPoliciesAfterLogIn,
  rejectLogIn,
  requestAcceptPendingToba,
  requestForgotPassword,
  requestForgotPasswordFailed,
  requestGetSessionExpirationDate,
  requestGetSessionExpirationDateFail,
  requestPendingToba,
  unauthorized,
  requestUnlockAragUserFailed,
} from './user';
import {
  badResponsePatchSolicitor,
  failedPostNewSolicitor,
  getSelectedSolicitorUser,
  patchExistingSolicitor,
  postNewSolicitor,
  postSendResetPasswordEmailToSolicitor,
  requestUnlockSolicitorUser,
  requestUnlockSolicitorUserFailed,
} from './newSolicitor';
import {
  failedGetSolicitors,
  failedGetSolicitorsSuggestions,
  getSolicitors,
  getSolicitorsSuggestions,
  requestSolicitorUserColleagues,
  requestSolicitorUserColleaguesFailed,
} from './agentsList';
import {
  badResponseUpdateSolicitor,
  badResponseUpdateSolicitorPassword,
  failedToReceiveSolicitorDetails,
  getAcceptedToba,
  getAcceptedTobaFail,
  getSolicitorDetails,
  updateSolicitorDetails,
  updateSolicitorPassWord,
  getLawsysDetails,
  failedToReceiveLawsysDetails,
} from './manageSolicitorAccount';
import {
  badRequestSolicitorGroup,
  badRespnseGetSolicitorGroupsSuggestions,
  badRespnsePatchSelectedSolicitorGroup,
  createdResponseNewSolicitor,
  getCasesAfterSolicitors,
  getExpensesAfterWorkSources,
  getSolicitorGroupAfterCaseTypes,
  getSolicitorGroups,
  getSolicitorGroupsAfterCreation,
  getSolicitorGroupsSuggestions,
  getSolicitorsAfterUnderwriters,
  getSolicitorSolicitorGroup,
  getUnderwriters,
  getUnderWritersAfterExpenses,
  getWorkSources,
  patchSelectedSolicitorGroup,
  patchSolicitorGroup,
  postNewSolicitorGroup,
  receiveFailedResponsePatchSolicitorGroup,
  receiveFailedResponseSolicitorGroups,
  solicitorGroupEdit,
  getGroupQuestionsSpec,
  getGroupSpecDto,
} from './solicitorGroup';
import {
  badGetQuestions,
  badResponsePatchPolicyQuestionsGroup,
  getFilteredPolicy,
  getApplicationFormTemplate,
  getPolicies,
  getQuestions,
  patchPolicyQuestionsGroup,
  postNewPolicy,
  receiveBadRequestPostNewPolicy,
  receiveFailedResponseGetPolicies,
  receiveFailResponseFilteredPolicy,
  requestCaseReferralKeywords,
  requestCaseReferralKeywordsFail,
  requestCreateCaseReferralKeyword,
  requestCreateCaseReferralKeywordFail,
} from './applicationFormReferralSettings';
import {
  badRequestPatchApplication,
  badResponseGetSelectedApp,
  deleteApplication,
  getApplication,
  getSelectedApplication,
  getSolicitorGroupWorkSources,
  getSubCaseTypesSelectedApplication,
  postNewApplication,
  receiveBadRequestGetApplication,
  receiveBadRequestGetSolicitorGroupWorkSources,
  receiveBadRequestPostNewApp,
  requestGetApplicationByIdAfterApplicationAnswerUpdate,
  requestGetApplicationByIdAfterApplicationAnswerUpdateFailed,
  requestGetApplicationByIdAfterApplicationUpdate,
  requestPatchApplication,
  requestUpdateFormQuestionAnswerAfterSubmit,
  requestUpdateFormQuestionAnswerAfterSubmitFail,
  getPolicyAsSolicitor,
  receiveBadRequestGetPolicyAsSolicitor,
  postNewApplicationAsSolicitor,
  receiveBadRequestPostNewAppAsSolicitor,
} from './newApplication';
import {
  badGetApplications,
  badGetApplicationsSuggestions,
  getAllApplications,
  getAllApplicationsSuggestions,
  getLastUpdatePolicy,
  receiveFailedResponseGetLastUpdatePolicy,
  updateSubCaseFilter,
} from './applicationsAndPolicies';

import {
  failedPatchUser,
  failedPostNewUser,
  patchUser,
  postNewUser,
  requestDeleteAragUser,
  requestDeleteAragUserFail,
  requestResetAragUserPassword,
  requestResetAragUserPasswordFail,
} from './manageUsers';
import {
  failedGetUsers,
  getUsers,
  requestAragUserById,
  requestAragUserByIdFail,
  requestUserGroups,
  requestUserGroupsFail,
  requestUserLevels,
  requestUserLevelsFail,
} from './usersList';
import {
  downloadFile,
  expiredToken,
  fetchUnseenNumberOnLocationChange,
  redirectToBaseUrlAfterLogOut,
  redirectToBaseUrlAfterSolicitorSetPassword,
  redirectToSolTableAfterSolGroupDelete,
} from './general';
import {
  getAllPreviousUpdates,
  getUpdateQuestions,
  postNoChangesUpdatePolicyForm,
  postUpdatePolicyForm,
  receiveBadRequestNoChangesPostUpdatePolicyForm,
  receiveBadRequestPostUpdatePolicyForm,
  receiveFailedResponseGetAllPreviousUpdates,
  receiveFailedResponseGetUpdateQuestions,
  requestUpdateTabTagsDescription,
  requestUpdateTabTagsDescriptionError,
  getCostsSummary,failedToGetCostsSummary,
} from './updateTab';
import {
  getApplicationOverview,
  getApplicatiovOverviewAfterPost,
  getApplicationReadByAragAfterPost,
  postOverviewPolicyForm,
  receiveBadRequestPostOverviewPolicyForm,
  receiveFailedResponseApplicationOverview,
  requestOverviewTabTagsDescription,
  requestOverviewTabTagsDescriptionFail,
} from './overviewTab';
import {
  deleteApplicationDocument,
  failureApplicationNotification,
  getApplicationAttachment,
  getApplicationAttachments,
  getApplicationNotification,
  getApplicationNotificationAfterApplicationOverviewChange,
  getApplicationNotificationAfterAragUserRequestUpdate,
  getApplicationNotificationAfterUpdate,
  getApplicationPremiumSettings,
  patchApplicationPremiumSettings,
  patchTransferApplicationBetweenSolicitors,
  receiveBadRequestPatchTransferApplicationBetweenSolicitors,
  postApplicationPremiumSettings,
  receiveBadRequestDeleteDocument,
  receiveBadRequestGetApplicationPremiumSettings,
  receiveBadRequestGoLiveAfterPremium,
  receiveBadRequestPatchApplicationPremiumSettings,
  receiveBadRequestPostApplicationPremiumSettings,
  receiveFailedResponseGetApplicationAttachment,
  receiveFailedResponseGetApplicationAttachments,
  requestApplicationPolicyIPID,
  requestApplicationPolicyWording,
  requestApplicationPolicyWordingFail,
  requestGetSolicitorGroupAfterAction,
  requestGoLiveAfterPremium,
  getApplicationPolicySchedule,
  failGetPolicySchedule,
  deleteApplicationPremiumSettings,
  receiveBadRequestDeleteApplicationPremiumSettings,
} from './ApplicationPolicy';
import{requestPostedApplicationMessage} from './submittedPolicy';
import {
  badGetNotifications,
  failedGetAllNotificationsIndicator,
  getAllNotifications,
  getAllNotificationsIndicator,
  patchNotification,
  receiveBadResponsePatchApplication,
  requestNotificationTypes,
  requestNotificationTypesFailed,
} from './notifications';
import {
  failedGetLawsysAgents,
  failedGetRequestLawsysFirmGroup,
  getLawsysAgents,
  getLawsysAgentsFiltered,
  failedGetLawsysAgentsFiltered,
  getRequestLawsysFirmGroup,
  getLawsysAgentsWithAgents,
  failedGetLawsysAgentsWithAgents,
  requestCheckLawsysFirmBankAccountValidityFailed,
  requestCheckLawsysFirmBankAccountValidity,
} from './lawsysFirms';

import {
  badResponseDeletePremiumSetting,
  badResponseGetPremiumSettingsStages,
  badResponsePatchPremiumSetting,
  badResponsePostNewPremiumSetting,
  deletePremiumSetting,
  failedGetAllPremiumSettins,
  failedGetAllPremiumSettinsForSol,
  failedRequestPremiumSettingsDamages,
  getAllPremiumSettings,
  getAllPremiumSettingsForSol,
  getCaseTypesAfterDamages,
  getPremiumSettingAfterSolicitors,
  getPremiumSettingById,
  getPremiumSettingsDamages,
  getPremiumSettingsStages,
  getSolicitorsAfterStages,
  getStagesAfterCaseTypes,
  getSubCaseTypeAfterGettingPremiumSetting,
  patchPremiumSetting,
  postNewPremiumSetting,
  receiveBadRequestGetPremiumSettingById,
  receiveBadResponseAllPremiumSettingsWithCombination,
  receiveBadResponsePremiumSettingsWithCombination,
  requestGetAllPremiumSettingsWithCombination,
  requestGetPremiumSettingWithCombination,
} from './premiumSettings';
import {
  requestStagedPremiumSetting,
  receiveBadRequestStagedPremiumSetting,
  requestAllStagedPremiumSettings,
  receiveBadRequestAllStagedPremiumSettings,
  requestSingleStagedPremiumSettings,
  receiveBadRequestSingleStagedPremiumSettings,
  resetDisplayedSetting,
} from './stagedPremiums';
import {
  requestPatchStagedPremiumSettings,
  receiveBadRequestPatchStagedPremiumSettings,
  createStagedPremiumSetting,
  receiveBadRequestCreateStagedPremiumSetting,
  getStagedPremiumSettingsStages,
  failedGetStagedPremiumSettingsStages,
  resetStagedPremiumReducers,
} from './stagedPremiumsWizard';
import {
  failedBreachCausationCp,
  getBreachCausationCp,
} from './breachCausationCp';
import {
  failedNewApplicationFormMessage,
  getNewApplicationFormMessage,
} from './newApplicationFormMessage';
import {
  badResponseUserSetPassword,
  postUserSetPassword,
} from './setUserPassword';
import {
  deleteSolicitorGroup,
  receiveBadResponseDeleteSolicitorGroup,
} from './solicitorGroupList';
import {
  badRequestGetSolicitorById,
  badRequestGetSolicitorGroupCaseTypes,
  badRequestGetUnderwriterOfSolicitor,
  errorRequestGroupExpensesTypes,
  getGroupsOfSolicitors,
  getSolicitorGroupById,
  getUnderwriterOfSolicitorGroup,
  receiveFailedResponseFromGettingGroupsOfSolicitors,
  receiveFailPatchSolGroup,
  reqPatchSolGroup,
  requestGroupExpensesCaseTypes,
  requestSolicitorGroupCaseTypes,
} from './groups';
import {
  badResponsePostNewToba,
  failedTobaMessage,
  getTobaMessage,
  postNewToba,
  replaceUrlTobaIdAfterPopulatingTobaFormFromRevision,
  requestTobaRevisionById,
  requestTobaRevisionByIdFail,
  requestTobaRevisions,
  requestTobaRevisionsAfterReceivingToba,
  requestTobaRevisionsFail,
  requestUpdateToba,
  requestUpdateTobaFail,
} from './toba';
import {failedGetStatuses, getApplicationStatuses} from './applicationStatuses';
import {
  failedGetAcceptedStatusesTransitions,
  getAcceptedStatusesTransitions,
} from './applicationAcceptedStatusesTransitions';
import {failedPostNewArticle, postNewArticle} from './articleForm';
import {
  deleteArticle,
  failedDeleteArticle,
  failedGetArticle,
  failedGetArticlesMessage,
  failedGetArticlesSolicitorHomePage,
  failedGetArticlesSuggestions,
  failedGetSpecificArticle,
  failedPatchArticle,
  getArticleAttachment,
  getArticleMessage,
  getArticles,
  getArticlesSolicitorHomePage,
  getArticlesSuggestions,
  getSpecificArticle,
  patchArticle,
  receiveFailedResponseGetArticleAttachment,
} from './articlesList';
import {
  badResponseGetApplicationIpt,
  badResponseGetApplicationsSchedules,
  getUnderwriterAfterSolicitorDetails,
  receiveBadRequestGetScheduleFooter,
  requestGetApplicationIpt,
  requestGetApplicationsSchedules,
  requestGetScheduleFooter,
} from './policyTab';
import {failedGetCaseTypesReq, reqGetCaseTypes} from './caseTypes';
import {
  failedToReceivePostResponsePremiumSettingWizard,
  failedToReceivePremiumSettingsWizardMessages,
  requestPostPremiumSettingWizard,
  requestPremiumSettingsWizardStepMessages,
  requestGetCoverageTypes,
  failedToGetCoverageTypes,
} from './premiumSettingsWizard';
import {
  getImagefileUrl,
  getImagesAfterloggingIn,
  receivedFailedResponseSolicitorHomeImages,
  requestSolicitorImages,
} from './solicitorImages';
import {
  getHomePageInfoAfterloggingIn,
  receiveFailedResponseSolicitorHomePageInfo,
  requestGetSolHomePageInfo,
} from './solicitorHomePageInfo';
import {
  receiveErrorGetExpenseTypes,
  requestGetExpenseTypes,
} from './expenseTypes';
import {
  receiveErrorDeletingToba,
  receiveErrorGetTobaById,
  receiveErrorRequestGetTobas,
  requestDeleteToba,
  requestGetTobaById,
  requestGetTobas,
  requestGetValidTobas,
  receiveErrorRequestGetValidTobas,
} from './tobas';
import {
  errorPostingAdvancedDisbursement,
  errorRequestAdvancedDisbursementsOfAPolicy,
  errorRequestAdvanceDisbursementById,
  errorRequestAdvanceDisbursementsStatuses,
  errorRequestAdvanceDisbursementsRejectionReasons,
  errorRequestAllAdvancedDisbursements,
  errorRequestAllAdvanceDisbursementsSuggestions,
  errorRequestEditAdvanceDisbursementById,
  postAdvancedDisbursement,
  requestAdvancedDisbursementsOfAPolicy,
  requestAdvanceDisbursementById,
  requestAdvanceDisbursementsStatuses,
  requestAdvanceDisbursementsRejectionReasons,
  requestAllAdvancedDisbursements,
  requestAllAdvanceDisbursementsSuggestions,
  requestApplicationAdUpdateStatus,
  requestApplicationAdUpdateStatusFail,
  requestEditAdvanceDisbursementById,
  requestGetAdvanceDisbursementsDueForPayment,
  requestGetAdvanceDisbursementsDueForPaymentFailed,
  requestGetStatementMessages,
  requestGetStatementMessagesFailed,
} from './advancedDisbursements';
import {
  requestEditingSettings,
  requestEditingSettingsEditableByOptions,
  requestEditingSettingsEditableByOptionsFailed,
  requestEditingSettingsFailed,
  requestUpdateEditingSettings,
  requestUpdateEditingSettingsFailed,
} from './editingSettings';
import {
  requestModeratePendingChange,
  requestModeratePendingChangeFailed,
  requestPendingChanges,
  requestPendingChangesFailed,
} from './pendingChanges';
import {
  requestQuestionAnswerRevisions,
  requestQuestionAnswerRevisionsFailed,
} from './questionAnswersRevisions';
import {requestWordingCategories} from './wordingCategories';
import {
  requestBrokerById,
  requestBrokerByIdFailed,
  requestCreateBroker,
  requestCreateBrokerFailed,
  requestUnlockBrokerUser,
  requestUnlockBrokerUserFailed,
  requestUpdateBrokerById,
  requestUpdateBrokerByIdFailed,
  requestUpdateBrokerPassword,
  requestUpdateBrokerPasswordFailed,
} from './broker';
import {
  requestBrokers,
  requestBrokersFailed,
  requestBrokersSuggestions,
  requestBrokersSuggestionsFailed,
} from './brokers';
import {
  requestBrokerFirms,
  requestBrokerFirmsFailed,
  requestBrokerFirmsWithAgents,
  requestBrokerFirmsWithAgentsFailed,
  getBrokerFirmsPostcodes,
  getBrokerFirmsPostcodesFailed,
  getBrokerFirmsFiltered,
  failedgetBrokerFirmsFiltered,
} from './brokerFirms';
import {
  requestCreateQuote,
  requestCreateQuoteFailed,
  requestQuoteById,
  requestQuoteByIdFailed,
  requestQuoteDefaultSettings,
  requestQuoteDefaultSettingsFailed,
  requestQuoteIPT,
  requestQuoteIPTFailed,
  requestQuoteMessages,
  requestQuoteMessagesFailed,
  requestQuotePolicyOverview,
  requestQuotePolicyOverviewFailed,
  requestQuoteProposalForms,
  requestQuoteProposalFormsFailed,
  requestQuotePolicyWordings,
  requestQuotePolicyWordingsFailed,
  requestQuotePointsOfSale,
  requestQuotePointsOfSaleFailed,
  requestQuoteQuestions,
  requestQuoteQuestionsFailed,
  requestQuoteScheduleInfo,
  requestQuoteScheduleInfoFailed,
  requestQuoteSchedulesMessage,
  requestQuoteSchedulesMessageFailed,
  requestQuoteStatuses,
  requestQuoteStatusesFailed,
  requestSendQuoteScheduleViaEmail,
  requestSendQuoteScheduleViaEmailFailed,
  requestUpdateQuote,
  requestUpdateQuoteFailed,
  requestQuoteMinimumPricing,
requestQuoteMinimumPricingFailed
} from "./quote";
import {requestQuotes, requestQuotesFailed, requestQuotesSuggestions, requestQuotesSuggestionsFailed} from "./quotes";
import {
  requestUpdateInternalAlertById,
  requestUpdateInternalAlertByIdFailed,
  requestCreateInternalAlert,
  requestCreateInternalAlertFail,
  resetInternalAlertsReducers,
  requestDeleteInternalAlert,
  badResponseDeleteInternalAlert
} from "./internalAlertForm";
import {
  requestInternalAlerts,
  requestInternalAlertsFailed,
  requestInternalAlertById,
  requestInternalAlertByIdFailed,
  requestApplicableInternalAlerts,
requestApplicableInternalAlertsFailed
} from "./internalAlerts";

export default combineCycles(
  logIn,
  rejectLogIn,
  requestDeleteInternalAlert,
  badResponseDeleteInternalAlert,
  getLawsysAgents,
  deleteApplicationPremiumSettings,
  receiveBadRequestDeleteApplicationPremiumSettings,
  getStagedPremiumSettingsStages,
  resetDisplayedSetting,
  resetStagedPremiumReducers,
  failedGetStagedPremiumSettingsStages,
  requestSingleStagedPremiumSettings,
  receiveBadRequestSingleStagedPremiumSettings,
  requestPatchStagedPremiumSettings,
  receiveBadRequestPatchStagedPremiumSettings,
  createStagedPremiumSetting,
  receiveBadRequestCreateStagedPremiumSetting,
  requestStagedPremiumSetting,
  receiveBadRequestStagedPremiumSetting,
  requestAllStagedPremiumSettings,
  receiveBadRequestAllStagedPremiumSettings,
  getBrokerFirmsFiltered,
  failedgetBrokerFirmsFiltered,
  getCostsSummary,failedToGetCostsSummary,
  updateSubCaseFilter,
  resetInternalAlertsReducers,
  requestApplicableInternalAlerts,
  requestApplicableInternalAlertsFailed,
  requestUpdateInternalAlertById,
  requestUpdateInternalAlertByIdFailed,
  requestCreateInternalAlert,
  requestCreateInternalAlertFail,
  requestInternalAlerts,
  requestInternalAlertsFailed,
  requestInternalAlertById,
  requestInternalAlertByIdFailed,
  requestQuoteMinimumPricing,
  requestQuoteMinimumPricingFailed,
  getBrokerFirmsPostcodes,
  getBrokerFirmsPostcodesFailed,
  requestGetCoverageTypes,
  failedToGetCoverageTypes,
  getApplicationPolicySchedule,
  failGetPolicySchedule,
  postNewApplicationAsSolicitor,
  receiveBadRequestPostNewAppAsSolicitor,
  getPolicyAsSolicitor,
  receiveBadRequestGetPolicyAsSolicitor,
  failedGetLawsysAgents,
  failedPostNewSolicitor,
  postNewSolicitor,
  getLawsysAgentsFiltered,
  failedGetLawsysAgentsFiltered,
  getSolicitors,
  failedGetSolicitors,
  requestPendingToba,
  requestAcceptPendingToba,
  logout,
  unauthorized,
  getSolicitorDetails,
  updateSolicitorDetails,
  getSolicitorSolicitorGroup,
  getUnderwriters,
  getWorkSources,
  postNewSolicitorGroup,
  createdResponseNewSolicitor,
  badRequestSolicitorGroup,
  getSolicitorGroups,
  patchSolicitorGroup,
  getPolicies,
  getQuestions,
  postNewPolicy,
  receiveBadRequestPostNewPolicy,
  getApplication,
  postNewApplication,
  receiveBadRequestPostNewApp,
  receiveBadRequestGetApplication,
  getAllApplications,
  badResponseUpdateSolicitor,
  requestPatchApplication,
  badRequestPatchApplication,
  postNewUser,
  failedPostNewUser,
  badGetApplications,
  badGetQuestions,
  getSelectedApplication,
  getAcceptedToba,
  deleteApplication,
  getUsers,
  failedGetUsers,
  patchUser,
  failedPatchUser,
  expiredToken,
  badResponseGetSelectedApp,
  getUpdateQuestions,
  postUpdatePolicyForm,
  receiveBadRequestPostUpdatePolicyForm,
  downloadFile,
  getLastUpdatePolicy,
  badResponsePatchSolicitor,
  getSubCaseTypesSelectedApplication,
  getApplicationOverview,
  getApplicatiovOverviewAfterPost,
  getApplicationReadByAragAfterPost,
  postOverviewPolicyForm,
  receiveBadRequestPostOverviewPolicyForm,
  getAllPreviousUpdates,
  redirectToBaseUrlAfterLogOut,
  deleteApplicationDocument,
  receiveBadRequestDeleteDocument,
  postNoChangesUpdatePolicyForm,
  receiveBadRequestNoChangesPostUpdatePolicyForm,
  getAllNotifications,
  badGetNotifications,
  patchNotification,
  receiveBadResponsePatchApplication,
  getAllPremiumSettings,
  failedGetAllPremiumSettins,
  getPremiumSettingsDamages,
  getPremiumSettingsStages,
  postNewPremiumSetting,
  badResponsePostNewPremiumSetting,
  patchPremiumSetting,
  badResponsePatchPremiumSetting,
  getBreachCausationCp,
  failedBreachCausationCp,
  getAllPremiumSettingsForSol,
  failedGetAllPremiumSettinsForSol,
  getNewApplicationFormMessage,
  failedNewApplicationFormMessage,
  postUserSetPassword,
  badResponseUserSetPassword,
  redirectToBaseUrlAfterSolicitorSetPassword,
  deleteSolicitorGroup,
  receiveBadResponseDeleteSolicitorGroup,
  redirectToSolTableAfterSolGroupDelete,
  patchSelectedSolicitorGroup,
  badRespnsePatchSelectedSolicitorGroup,
  getGroupsOfSolicitors,
  getSelectedSolicitorUser,
  patchExistingSolicitor,
  getApplicationAttachments,
  getSolicitorGroupById,
  badRequestGetSolicitorById,
  deletePremiumSetting,
  badResponseDeletePremiumSetting,
  solicitorGroupEdit,
  getSolicitorsAfterUnderwriters,
  getPremiumSettingById,
  getStagesAfterCaseTypes,
  receiveBadRequestGetPremiumSettingById,
  getCaseTypesAfterDamages,
  getSubCaseTypeAfterGettingPremiumSetting,
  getSolicitorGroupWorkSources,
  receiveBadRequestGetSolicitorGroupWorkSources,
  postNewToba,
  badResponsePostNewToba,
  getApplicationPremiumSettings,
  postApplicationPremiumSettings,
  patchApplicationPremiumSettings,
  patchTransferApplicationBetweenSolicitors,
  receiveBadRequestPatchTransferApplicationBetweenSolicitors,
  receiveBadRequestGetApplicationPremiumSettings,
  receiveBadRequestPostApplicationPremiumSettings,
  receiveBadRequestPatchApplicationPremiumSettings,
  postSendResetPasswordEmailToSolicitor,
  updateSolicitorPassWord,
  badResponseUpdateSolicitorPassword,
  requestGoLiveAfterPremium,
  receiveBadRequestGoLiveAfterPremium,
  getVersion,
  getApplicationStatuses,
  failedGetStatuses,
  failedGetAcceptedStatusesTransitions,
  getAcceptedStatusesTransitions,
  postNewArticle,
  failedPostNewArticle,
  getArticles,
  failedGetArticle,
  patchArticle,
  failedPatchArticle,
  deleteArticle,
  failedDeleteArticle,
  getSpecificArticle,
  failedGetSpecificArticle,
  getUnderwriterOfSolicitorGroup,
  badRequestGetUnderwriterOfSolicitor,
  requestGetApplicationIpt,
  badResponseGetApplicationIpt,
  requestGetApplicationsSchedules,
  badResponseGetApplicationsSchedules,
  failedToReceiveSolicitorDetails,
  getUnderwriterAfterSolicitorDetails,
  requestGetSolicitorGroupAfterAction,
  patchPolicyQuestionsGroup,
  badResponsePatchPolicyQuestionsGroup,
  reqGetCaseTypes,
  failedGetCaseTypesReq,
  getSolicitorGroupAfterCaseTypes,
  getCasesAfterSolicitors,
  badRequestGetSolicitorGroupCaseTypes,
  requestSolicitorGroupCaseTypes,
  failedRequestPremiumSettingsDamages,
  badResponseGetPremiumSettingsStages,
  requestPostPremiumSettingWizard,
  failedToReceivePostResponsePremiumSettingWizard,
  requestGetPremiumSettingWithCombination,
  receiveBadResponsePremiumSettingsWithCombination,
  failedToReceivePremiumSettingsWizardMessages,
  requestPremiumSettingsWizardStepMessages,
  requestGetAllPremiumSettingsWithCombination,
  receiveBadResponseAllPremiumSettingsWithCombination,
  getSolicitorsAfterStages,
  getPremiumSettingAfterSolicitors,
  getArticleMessage,
  failedGetArticlesMessage,
  receiveFailedResponseFromGettingGroupsOfSolicitors,
  receiveFailedResponseGetPolicies,
  receiveFailedResponseGetApplicationAttachments,
  receiveFailedResponseGetLastUpdatePolicy,
  receiveFailedResponsePatchSolicitorGroup,
  receiveFailedResponseGetUpdateQuestions,
  receiveFailedResponseGetPendingToba,
  receiveFailedResponseAcceptPendingToba,
  getSolicitorsSuggestions,
  failedGetSolicitorsSuggestions,
  getSolicitorGroupsAfterCreation,
  badRespnseGetSolicitorGroupsSuggestions,
  getSolicitorGroupsSuggestions,
  getAllApplicationsSuggestions,
  badGetApplicationsSuggestions,
  receiveFailedResponseApplicationOverview,
  receiveFailedResponseGetAllPreviousUpdates,
  getApplicationAttachment,
  receiveFailedResponseGetApplicationAttachment,
  getArticleAttachment,
  receiveFailedResponseGetArticleAttachment,
  requestSolicitorImages,
  receivedFailedResponseSolicitorHomeImages,
  requestGetSolHomePageInfo,
  receiveFailedResponseSolicitorHomePageInfo,
  getTobaMessage,
  failedTobaMessage,
  askForNotificationsIndicatorAfterLogIn,
  getAllNotificationsIndicator,
  failedGetAllNotificationsIndicator,
  reqPatchSolGroup,
  receiveFailPatchSolGroup,
  getApplicationNotification,
  failureApplicationNotification,
  getArticlesSolicitorHomePage,
  failedGetArticlesSolicitorHomePage,
  getArticlesSuggestions,
  failedGetArticlesSuggestions,
  getImagesAfterloggingIn,
  getHomePageInfoAfterloggingIn,
  receiveFailedResponseSolicitorGroups,
  getImagefileUrl,
  getFilteredPolicy,
  getApplicationFormTemplate,
  receiveFailResponseFilteredPolicy,
  getRequestLawsysFirmGroup,
  failedGetRequestLawsysFirmGroup,
  fetchUnseenNumberOnLocationChange,
  redirectSolicitorUserToPoliciesAfterLogIn,
  requestGetTobaById,
  receiveErrorGetTobaById,
  requestDeleteToba,
  receiveErrorDeletingToba,
  requestGetTobas,
  receiveErrorRequestGetTobas,
  requestUpdateTabTagsDescription,
  requestUpdateTabTagsDescriptionError,
  requestOverviewTabTagsDescription,
  requestOverviewTabTagsDescriptionFail,
  requestUserGroups,
  requestUserGroupsFail,
  requestUserLevels,
  requestUserLevelsFail,
  requestTobaRevisions,
  requestTobaRevisionsFail,
  requestAragUserById,
  requestAragUserByIdFail,
  requestApplicationPolicyWording,
  requestApplicationPolicyWordingFail,
  requestGetValidTobas,
  receiveErrorRequestGetValidTobas,
  getApplicationNotificationAfterUpdate,
  getApplicationNotificationAfterAragUserRequestUpdate,
  getApplicationNotificationAfterApplicationOverviewChange,
  requestUpdateToba,
  requestUpdateTobaFail,
  requestTobaRevisionById,
  requestTobaRevisionByIdFail,
  replaceUrlTobaIdAfterPopulatingTobaFormFromRevision,
  getAcceptedTobaFail,
  redirectAfterAcceptingToba,
  requestTobaRevisionsAfterReceivingToba,
  getLawsysAgentsWithAgents,
  failedGetLawsysAgentsWithAgents,
  redirectAragUserAfterLogIn,
  requestResetAragUserPassword,
  requestResetAragUserPasswordFail,
  requestDeleteAragUser,
  requestDeleteAragUserFail,
  requestUpdateFormQuestionAnswerAfterSubmit,
  requestUpdateFormQuestionAnswerAfterSubmitFail,
  requestGetSessionExpirationDate,
  requestGetSessionExpirationDateFail,
  receiveErrorGetExpenseTypes,
  requestGetExpenseTypes,
  getExpensesAfterWorkSources,
  getUnderWritersAfterExpenses,
  requestGetTobas,
  receiveErrorRequestGetTobas,
  postAdvancedDisbursement,
  errorPostingAdvancedDisbursement,
  requestAdvancedDisbursementsOfAPolicy,
  errorRequestAdvancedDisbursementsOfAPolicy,
  requestAllAdvancedDisbursements,
  errorRequestAllAdvancedDisbursements,
  requestGroupExpensesCaseTypes,
  errorRequestGroupExpensesTypes,
  requestAllAdvanceDisbursementsSuggestions,
  errorRequestAllAdvanceDisbursementsSuggestions,
  requestAdvanceDisbursementById,
  errorRequestAdvanceDisbursementById,
  requestEditAdvanceDisbursementById,
  errorRequestEditAdvanceDisbursementById,
  requestAdvanceDisbursementsStatuses,
  errorRequestAdvanceDisbursementsStatuses,
  requestAdvanceDisbursementsRejectionReasons,
  errorRequestAdvanceDisbursementsRejectionReasons,
  requestApplicationAdUpdateStatus,
  requestApplicationAdUpdateStatusFail,
  requestForgotPasswordFailed,
  requestForgotPassword,
  requestCreateBroker,
  requestCreateBrokerFailed,
  requestBrokers,
  requestBrokersFailed,
  requestBrokersSuggestions,
  requestBrokersSuggestionsFailed,
  requestBrokerById,
  requestBrokerByIdFailed,
  requestUpdateBrokerById,
  requestUpdateBrokerByIdFailed,
  requestBrokerFirms,
  requestBrokerFirmsFailed,
  requestUpdateBrokerPassword,
  requestUpdateBrokerPasswordFailed,
  requestBrokerFirmsWithAgents,
  requestBrokerFirmsWithAgentsFailed,
  requestQuoteQuestions,
  requestQuoteQuestionsFailed,
  requestQuoteStatuses,
  requestQuoteStatusesFailed,
  requestCreateQuote,
  requestCreateQuoteFailed,
  requestUpdateQuote,
  requestUpdateQuoteFailed,
  requestQuoteIPT,
  requestQuoteIPTFailed,
  requestQuoteDefaultSettings,
  requestQuoteDefaultSettingsFailed,
  requestQuoteMessages,
  requestQuoteMessagesFailed,
  requestQuotePolicyOverview,
  requestQuotePolicyOverviewFailed,
  requestQuotes,
  requestQuotesFailed,
  requestQuotesSuggestions,
  requestQuotesSuggestionsFailed,
  requestQuoteById,
  requestQuoteByIdFailed,
  requestQuoteSchedulesMessage,
  requestQuoteSchedulesMessageFailed,
  requestSendQuoteScheduleViaEmail,
  requestSendQuoteScheduleViaEmailFailed,
  requestQuoteProposalForms,
  requestQuoteProposalFormsFailed,
  requestQuoteScheduleInfo,
  requestQuoteScheduleInfoFailed,
  requestNotificationTypesFailed,
  requestNotificationTypes,
  requestCheckLawsysFirmBankAccountValidity,
  requestCheckLawsysFirmBankAccountValidityFailed,
  requestGetAdvanceDisbursementsDueForPayment,
  requestGetAdvanceDisbursementsDueForPaymentFailed,
  requestGetStatementMessages,
  requestGetStatementMessagesFailed,
  requestUpdateEditingSettings,
  requestUpdateEditingSettingsFailed,
  requestEditingSettings,
  requestEditingSettingsFailed,
  requestEditingSettingsEditableByOptions,
  requestEditingSettingsEditableByOptionsFailed,
  requestPendingChanges,
  requestPendingChangesFailed,
  requestModeratePendingChange,
  requestModeratePendingChangeFailed,
  requestQuestionAnswerRevisions,
  requestQuestionAnswerRevisionsFailed,
  requestSolicitorUserColleaguesFailed,
  requestSolicitorUserColleagues,
  requestNotificationTypesFailed,
  requestNotificationTypes,
  requestGetApplicationByIdAfterApplicationAnswerUpdate,
  requestGetApplicationByIdAfterApplicationAnswerUpdateFailed,
  requestUnlockSolicitorUser,
  requestUnlockSolicitorUserFailed,
  requestCreateCaseReferralKeyword,
  requestCreateCaseReferralKeywordFail,
  requestCaseReferralKeywords,
  requestCaseReferralKeywordsFail,
  requestApplicationPolicyIPID,
  requestGetApplicationByIdAfterApplicationUpdate,
  requestWordingCategories,
  failedToReceiveLawsysDetails,
  getLawsysDetails,
  getGroupQuestionsSpec,
  getGroupSpecDto,
  requestUnlockAragUser,
  requestUnlockAragUserFailed,
  requestUnlockBrokerUser,
  requestUnlockBrokerUserFailed,
  requestQuotePolicyWordings,
  requestQuotePolicyWordingsFailed,
  requestQuotePointsOfSale,
  requestQuotePointsOfSaleFailed,
  requestPostedApplicationMessage,
);
